import {NgModule} from "@angular/core";
import {AddressEditComponent} from "./address-edit/address-edit.component";
import {FrameworkModule} from "../framework/framework.module";
import {SharedModule} from "../shared/shared.module";
import {CountrySingleSelectEditControlComponent} from "./controls/country-single-select-edit-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
        AddressEditComponent,
        CountrySingleSelectEditControlComponent
    ],
    exports: [
        AddressEditComponent,
        CountrySingleSelectEditControlComponent
    ]
})
export class AddressSharedModule {
}
